import { 
    CalendarDays, 
    Codesandbox, 
    MonitorDot, 
    FileText, 
    User, 
    Package, 
    CheckCircle, 
    UserRound, 
    ScrollText,
    Clock,
    Calendar,
    ClipboardList,
    Receipt,
    Settings,
    UserCog,
    MessageCircle,
    HelpCircle,
    Route,
} from "lucide-react";

const menuDataEmployee: any = [
    // Dashboard Section
    {
        id: "dashboard",
        label: 'Dashboard',
        link: "/dashboard",
        icon: <MonitorDot className="text-blue-500 hover:text-blue-600 transition-colors" />,
        className: "hover:bg-blue-50 border-l-4 border-transparent hover:border-blue-500 transition-all duration-200"
    },

    // Communication & Collaboration Section
    {
        label: 'Communication',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'engage',
        label: 'Engage',
        icon: <MessageCircle className="text-teal-500 hover:text-teal-600 transition-colors" />,
        link: '/apps-engage',
        parentId: 2,
        roles: ['Admin', 'Super Admin'],
        className: "hover:bg-teal-50 border-l-4 border-transparent hover:border-teal-500 transition-all duration-200"
    },
    {
        id: 'notes',
        label: 'Notes',
        icon: <ScrollText className="text-amber-500 hover:text-amber-600 transition-colors" />,
        link: '/apps-notes',
        parentId: 2,
        className: "hover:bg-amber-50 border-l-4 border-transparent hover:border-amber-500 transition-all duration-200"
    },
    {
        id: 'calendar',
        label: 'Calendar',
        link: '/apps-calendar',
        icon: <Calendar className="text-pink-500 hover:text-pink-600 transition-colors" />,
        parentId: 2,
        className: "hover:bg-pink-50 border-l-4 border-transparent hover:border-pink-500 transition-all duration-200"
    },

    // Attendance & Updates Section
    {
        label: 'Attendance & Updates',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'attendance-emp',
        label: 'Attendance',
        link: '/attendance',
        icon: <Clock className="text-blue-500 hover:text-blue-600 transition-colors" />,
        parentId: 2,
        className: "hover:bg-blue-50 border-l-4 border-transparent hover:border-blue-500 transition-all duration-200"
    },
    {
        id: 'daily-updates-form-emp',
        label: 'Daily Updates Form',
        link: '/daily-updates-form',
        icon: <ClipboardList className="text-emerald-500 hover:text-emerald-600 transition-colors" />, 
        parentId: 2,
        className: "hover:bg-emerald-50 border-l-4 border-transparent hover:border-emerald-500 transition-all duration-200"
    },
    {
        id: 'user-trips',
        label: 'Travel Tracker',
        link: '/personal-trips',
        icon: <Route className="text-indigo-500 hover:text-indigo-600 transition-colors" />,
        parentId: 2,
        className: "hover:bg-indigo-50 border-l-4 border-transparent hover:border-indigo-500 transition-all duration-200",
        dynamicLink: true
    },

    // HR Management Section
    {
        label: 'HR Management',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'leaves',
        label: 'Leave',
        icon: <CalendarDays className="text-cyan-500 hover:text-cyan-600 transition-colors" />,
        parentId: 2,
        className: "hover:bg-cyan-50 border-l-4 border-transparent hover:border-cyan-500 transition-all duration-200",
        subItems: [
            {
                id: 'leaves-form',
                label: 'Leave Form',
                link: '/apply-for-leaves',
                parentId: 'leaves',
                className: "hover:bg-cyan-100 ml-4 border-l-2 border-transparent hover:border-cyan-400 transition-all duration-200"
            },
            {
                id: 'leaves-list',
                label: 'My Leaves',
                link: '/leaves',
                parentId: 'leaves',
                className: "hover:bg-cyan-100 ml-4 border-l-2 border-transparent hover:border-cyan-400 transition-all duration-200"
            },
        ]
    },

    // Finance Section
    {
        label: 'Finance',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },

    {
        label: 'Ticket Management',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'my-tickets',
        label: 'My Tickets',
        icon: <FileText className="text-emerald-600 hover:text-emerald-700 transition-colors" />,
        link: '/my-tickets',
        parentId: 2,
        className: "hover:bg-emerald-50 border-l-4 border-transparent hover:border-emerald-500 transition-all duration-200"
    },

    // System Section
    {
        label: 'System',
        isTitle: true,
        className: "text-xs font-semibold text-gray-500 uppercase tracking-wider mt-6 mb-2 px-3"
    },
    {
        id: 'pages-emp',
        label: 'More Options',
        icon: <Settings className="text-gray-500 hover:text-gray-600 transition-colors" />,
        parentId: 2,
        className: "hover:bg-gray-50 border-l-4 border-transparent hover:border-gray-500 transition-all duration-200",
        subItems: [
            {
                id: 'settings-emp',
                label: 'My Profile',
                link: '/employees/profile',
                parentId: 'pages-emp',
                icon: <UserCog className="text-purple-500 hover:text-purple-600 transition-colors" />,
                className: "hover:bg-gray-100 ml-4 border-l-2 border-transparent hover:border-gray-400 transition-all duration-200"
            },
            // {
            //     id: 'contact-us-emp',
            //     label: 'Contact Us',
            //     link: 'https://irecman.com/contact',
            //     // target="_blank",
            //     parentId: 'pages-emp',
            //     icon: <User />
            // }
        ]
    },
];

export { menuDataEmployee };
